<div class="masthead-container masthead-text" [class.masthead-rail]="bitsStateService.navMode() !== 'hamburger'">
  <!-- Hamburger Menu -->
  <!-- < button class="masthead-hamburger-button" (click)="sidenav.toggle()"><mat-icon>{{ this.sidenav.opened ? "menu_open" : "menu" }}</mat-icon></button> -->
  <div class="masthead-hamburger-button-container">
    @if (bitsStateService.navMode() === 'hamburger') {
    <ui-button class="masthead-hamburger-button" (click)="toggle(bitsStateService.sideNavOpen)">
      <mat-icon>{{ bitsStateService.sideNavOpen() ? "menu_open" : "menu" }}</mat-icon>
    </ui-button>
    }
  </div>

  @if (bitsStateService.navMode() === 'hamburger') {
    <!-- PHMS Logo (using routerLink for SPA refresh, with some dev love with alternate routes :)-->
    <a routerLink="/" alternateRoute shiftUrl="{{baseHref}}" ctrlUrl="/bits" altUrl="/bits2" class="masthead-logo font-bold no-underline"  >
      <app-phms-brand-mark></app-phms-brand-mark>
    </a>

    <!-- PHMS App Title -->
    <a routerLink="/" alternateRoute shiftUrl="{{baseHref}}" ctrlUrl="/bits" altUrl="/bits2" class="no-underline">
      <span class="masthead-app-title masthead-phms-wordmark">Parole Hearing Management System</span>
    </a>
  }

  <app-breadcrumb class="masthead-breadcrumbs"></app-breadcrumb>

  @if(bitsStateService.devModeSignal())
  {
  <!-- Spacer -->
  <span class="grow"></span>
  <!-- <span style="color: white;">CDC Num Signal: {{ cdcNumFromPath() }}</span>
    <span style="color: white;">CDC Num Signal: {{ cdcNumSignal() }}</span> -->
  <span class="flex" *ngIf="queryParamsAsObjectSig()">
    <span><b>Query Params:&nbsp; </b></span>
    <span *ngFor="let item of queryParamsAsObjectSig() | keyValuePairs; let last = last">
      {{ item.key }}=<b>{{ item.value }}</b><span *ngIf="!last">, &nbsp;</span>
    </span>
  </span>
  <span>Enable workflow: <b>{{this.bitsStateService.enableSummaryBarWorkflowSig()}}</b></span>
  <ui-button class="masthead-nav-mode-toggle" (click)="toggleNavLayout()">
    <mat-icon>swap_horiz</mat-icon>
    {{ bitsStateService.navMode() === 'hamburger' ? 'Rail Nav' : 'Hamburger Nav' }}
  </ui-button>

  <!-- Spacer -->
  <span class="grow"></span>

  <!-- Short lived message for development -->
  <span class="dev-message" [innerHTML]="devMessageSig()"></span>
  }

  <!-- Spacer -->
  <span class="grow"></span>

  <!-- Enable this if you want to switch theme/variant directly in the masthead. Also good for testing the signal -->
  <!--
  < button (click)="cycleTheme()"> <mat-icon [fontIcon]="'celebration'"></mat-icon>{{ currentTheme }} theme </button>
  < button (click)="cycleThemeMode()"> <mat-icon [fontIcon]="themeModeIcon" style="width: 30px"></mat-icon> </button>
  -->

  <!-- Alerts -->
  <!-- <app-alerts-header-button /> -->
  <ui-button class="change-me" *ngIf="alertService.showAlerts()" [config]="myAlertsButtonConfig" />

  <!-- Search bar removed from the masthead at the user's request. -->
  <!-- <app-masthead-search *ngIf="showSearch"></app-masthead-search> -->

  <!-- <app-general-search></app-general-search> -->

  <!-- Rubik's Cube -->
  <!-- <app-masthead-rubiks-cube></app-masthead-rubiks-cube> -->

  <app-theme-menu></app-theme-menu>
  <app-user-menu></app-user-menu>

</div>

<div class="app-loader-container">
  <app-loader></app-loader>
</div>
